import { useParams } from 'react-router'
import { FormWrapper } from '@/form-control'
import { SelectField, TextField } from '@/form-control/fields'
import ROUTES from '@/ROUTES'

import { IProvider } from '@/MODELS/provider.model'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'

export default function AdminproviderForm(props: { id?: string }) {
    const params = useParams()
    const id = props?.id ?? params?.id ?? 'new'

    return (
        <>
            <AdminPageHeader heading={id ? 'Edit provider' : 'Create New provider'} />
            <FormWrapper<IProvider>
                endpoint={ROUTES.admin.provider}
                id={id}
                redirectAfterSubmit='/admin/providers'
                additionalSubmissionRowContent={
                    <div className='flex items-center justify-between w-full gap-x-2 h-fit'>
                        <Button.Back />
                    </div>
                }
            >
                {(f) => (
                    <div className='overflow-hidden bg-white border-gray-200 shadow-sm rounded-xl'>
                        <div className='p-6 space-y-6'>
                            <div className='grid gap-6 lg:grid-cols-2'>
                                <div className='lg:col-span-2'>
                                    {' '}
                                    <TextField {...f('name')} label='Name' />
                                </div>
                                <TextField {...f('email')} label='Email' />
                                <TextField {...f('phone')} label='Phone' />
                                <TextField {...f('website')} label='Website Link' />
                                <SelectField
                                    optionsListConfig={{
                                        endpoint: ROUTES.admin.providerCategories,
                                        textKey: 'name',
                                    }}
                                    {...f('category')}
                                    label='Category'
                                />
                            </div>
                        </div>

                        <div className='p-6 space-y-6'>
                            <div className='grid gap-6 lg:grid-cols-2'>
                                <TextField {...f('city')} label='City' />
                                <TextField {...f('state')} label='State' />
                                <div className='lg:col-span-2'>
                                    <TextField {...f('address')} label='Full Address' />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </FormWrapper>
        </>
    )
}
